import React, {useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import Layout from '~/Components/Layout/Layout';
import GuestPreview from './GuestPreview';
import Moment from 'react-moment';
import {useHistory} from 'react-router';
import {startGuestProgress} from "~/redux/actions/guests";
import {submitInvitationAction} from "~/redux/actions/invitation";
import {setActiveStepAction, setActiveGuestAction} from "~/redux/actions/guests";
import {invitationReady} from '~/helpers/invitation';

import './preview.scss';
import {Link} from "react-router-dom";
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import ActionPrompt from '../../Components/ActionPrompt/ActionPrompt';
import Translate from '../../Components/ContentTranslate/Translate';
import { requestEditSubmittedRegistration } from '../../redux/actions/invitation';

const RsvpPreview = ({invitation, guests, activeGuest, currentLanguage, ...props}) => {
    if (!invitation) { return ''; }

    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const actionPromptRef = useRef();
    const rsvpPreviewRef = useRef();

    function handleEditInfo(tab, index) {
        props.dispatch(setActiveGuestAction(index));
        props.dispatch(setActiveStepAction(tab));
        history.push('/registration');
    }

    const handleStartGuest = (guest, index) => {
        setLoading(true);
        props.dispatch(startGuestProgress(guest.id)).then(() => {
            handleEditInfo('personal_details', index);
        }).finally(() => setLoading(false));
    }

    const submitRegistration = () => {
        setLoadingSubmit(true);
        props.dispatch(submitInvitationAction(invitation.id))
            .finally(() => setLoadingSubmit(false));
    }

    const editRegistration = () => {
        setLoadingSubmit(true);
        props.dispatch(requestEditSubmittedRegistration(invitation.id))
            .finally(() => setLoadingSubmit(false));
    }

    useEffect(() => {
        if(actionPromptRef?.current) {
            rsvpPreviewRef.current.style.marginBottom = `${actionPromptRef.current.offsetHeight}px`
        }
    }, [])

    const formFinished = invitationReady(guests);
    const submitted = invitation.registration_status === 'submitted';
    const currentGuest = guests[activeGuest];

    return (
        <Layout colorBg>
            <div className="container container-preview">

                <div className="row">
                    <div className="registration-card col-lg-3 col-12">
                        <div className="card overview shadow-sm bg-white">
                            <div className="card-body">
                                <div className="card-title"><TextTranslate name="reg-your-registration" fallback="Your Registration"/></div>
                                <div className="row">
                                    <div className="col-6 text-primary"><TextTranslate name="reg-status" fallback="Status"/></div>
                                    <TextTranslate className="col-6 p-0" name={`reg-status-${invitation.registration_status}`}/>
                                </div>
                                <div className="row">
                                    <div className="col-6 text-primary"><TextTranslate name="reg-number-invitees" fallback="Number Of Invitees"/></div>
                                    <div className="col-6 p-0">{invitation.guest_allowance}</div>
                                </div>
                                <div className="row">
                                    <div className="col-6 text-primary"><TextTranslate name="reg-deadline" fallback="Deadline"/></div>
                                    <div className="col-6 p-0">
                                        <Moment locale={currentLanguage.code} format="DD/MM/YYYY" date={invitation.event.reg_deadline}/>
                                    </div>
                                </div>

                                {guests.map((guest, index) => {
                                    return (
                                        <div key={`guest-tab_${index}`}>
                                            <hr/>
                                            <div className="row mb-0">

                                                <div className="col-6 text-type-caption">
                                                    {guest.main ?
                                                        <TextTranslate name="reg-main-guest" fallback="Main Guest"/> :
                                                        <><TextTranslate name="reg-guest-number" fallback="Guest #"/> {index}</>
                                                    }
                                                </div>

                                                <div className="col-6 text-caption text-primary text-right">

                                                    {guest.started && (
                                                        <span>{guest.progress.complete}/{guest.progress.total} <TextTranslate name="word-complete" fallback="Complete"/></span>
                                                    )}

                                                    {!guest.started && !submitted && (
                                                        <a
                                                            className="mb-0 link text-primary"
                                                            disabled={loading}
                                                            onClick={() => handleStartGuest(guest, index)}
                                                        >
                                                            <TextTranslate name="reg-click-to-start" fallback="Click to start"/>
                                                        </a>
                                                    )}

                                                    {!guest.started && submitted && (
                                                        <span><TextTranslate name="reg-guest-deleted" fallback="Guest Deleted!"/></span>
                                                    )}

                                                </div>

                                            </div>
                                            {
                                                guest.first_name || guest.last_name ?
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="card-title mb-0">
                                                            {guest.first_name} {guest.last_name}
                                                        </div>
                                                    </div>
                                                </div> : null
                                            }
                                        </div>
                                    );
                                })}

                            </div>
                        </div>
                        {formFinished && !submitted && (
                            <div className="card overview shadow-sm bg-white mt-3">
                                <div className="card-body text-right">
                                    <ConfirmedButton
                                        disabled={loadingSubmit}
                                        onClick={(e) => submitRegistration()}
                                        className="btn w-100 btn-primary btn-sm">
                                            <TextTranslate name="reg-submit-registration" fallback="Submit registration"/>
                                    </ConfirmedButton>
                                </div>
                            </div>
                        )}

                        {formFinished && submitted && (
                            <div className="card overview shadow-sm bg-white mt-3">
                                <div className="card-body text-right">
                                    <ConfirmedButton
                                        disabled={loadingSubmit}
                                        onClick={(e) => editRegistration()}
                                        className="btn w-100 btn-primary btn-sm">
                                            <TextTranslate name="reg-edit-registration" fallback="Edit registration"/>
                                    </ConfirmedButton>
                                </div>
                            </div>
                        )}
                    </div>
                    <div ref={rsvpPreviewRef} className="rsvp-preview col-lg-9 col-12 mt-3 mt-lg-0">

                        {submitted && (
                            <div className="card overview shadow-sm bg-white mb-4">
                                <div className="card-body">
                                    <h1 className="text-primary"><TextTranslate name="reg-submitted-msg" fallback="Congrats! Your registration is submitted!"/></h1>
                                    <p><b><TextTranslate name="word-next-step" fallback="Next steps"/></b>:<br/>
                                        <span
                                            className="pre-line"
                                            dangerouslySetInnerHTML={{__html:invitation.event?.submitted_message_groups?.[currentGuest?.guest_group] || ''}}
                                        >
                                            {/* <TextTranslate
                                                fallback={invitation.event?.submitted_message?.message}
                                                currentLanguage={currentLanguage}
                                                translations={invitation.event?.submitted_message_groups?.[currentGuest.guest_group] || ''}
                                            /> */}
                                            {/*<Translate model={invitation.event?.submitted_message} field='message' />*/}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        )}

                        {guests.map((guest, index) =>
                            <GuestPreview
                                key={`guest-preview-card_${index}`}
                                guest={guest}
                                index={index}/>
                        )}

                        {/* {formFinished && !submitted && (
                            <div className="card overview shadow-sm bg-white mt-3">
                                <div className="card-body text-right">
                                    <div className="row">
                                        <div className="col-6">
                                            <Link to="/registration" className="btn w-100 btn-secondary">
                                                <TextTranslate name="reg-continue-editing" fallback="Continue editing"/>
                                            </Link>
                                        </div>
                                        <div className="col-6">
                                            <ConfirmedButton
                                                disabled={loadingSubmit}
                                                onClick={(e) => submitRegistration()}
                                                className="btn w-100 btn-primary">
                                                    <TextTranslate name="reg-submit-registration" fallback="Submit registration"/>
                                            </ConfirmedButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )} */}

                        {formFinished && !submitted && (
                            <ActionPrompt
                                desktop={true}
                                follow={true}
                                classes=""
                                ref={actionPromptRef}
                            >
                                <Link to="/registration" className="btn btn-text-only text-uppercase">Continue Editing</Link>
                                <button
                                    className="btn btn-primary text-uppercase"
                                    onClick={(e) => submitRegistration()}
                                    disabled={loadingSubmit}
                                >
                                    <TextTranslate name="reg-submit-registration" fallback="Submit registration"/>
                                </button>
                            </ActionPrompt>
                        )}
                    </div>
                </div>

            </div>
        </Layout>
);
}

const mapStateToProps = (state) => (
    {
        currentLanguage: state.translations?.currentLanguage,
        auth: state.auth,
        invitation: state.invitation?.data,
        guests: state.guests?.list || [],
        activeStep: state.guests?.activeStep[state.guests?.activeGuest],
        activeGuest: state.guests?.activeGuest
    }
);

export default connect(mapStateToProps)(RsvpPreview);
